import { ReactNode } from 'react'
import { Button } from 'antd'
import { Footer, Root, Title } from './styled'

interface IProps {
  title: string
  secondaryLabel: string
  primaryLabel: string
  onSecondary: () => void
  onPrimary: () => void
  primaryDisabled?: boolean
  primaryTestId?: string
  children: ReactNode
}

/** Survey editor chrome shared by the course block and the bank. */
export const SurveyEditorShell = ({
  title,
  secondaryLabel,
  primaryLabel,
  onSecondary,
  onPrimary,
  primaryDisabled,
  primaryTestId,
  children,
}: IProps) => (
  <Root>
    <Title>{title}</Title>
    {children}
    <Footer>
      <Button onClick={onSecondary}>{secondaryLabel}</Button>
      <div>
        <Button
          data-testid={primaryTestId}
          disabled={primaryDisabled}
          onClick={onPrimary}
        >
          {primaryLabel}
        </Button>
      </div>
    </Footer>
  </Root>
)
